module.exports = __webpack_public_path__ + "static/img/retention-banner.9d24378.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/retention-banner.svg
// module id = 7mOr
// module chunks = 1